// useResponsiveClass.ts
import { useScreenSize } from '@/utils/useScreenSize';

type ClassMap = Partial<{
  mobile: string;
  tablet: string;
  desktop: string;
}>;

export function useResponsiveClass() {
  const { isMobile, isTablet, isDesktop } = useScreenSize();

  const getClass = (classMap: ClassMap): string => {
    if (isMobile) return classMap.mobile ?? '';
    if (isTablet) return classMap.tablet ?? '';
    return classMap.desktop ?? '';
  };

  return Object.assign(getClass, {
    isMobile,
    isTablet,
    isDesktop,
  });
}
